import axios from 'axios';
import { useEffect, useState } from 'react';
import { msToTime } from '../../util/fns';
import { api_bd_nr } from '../../services/Api';

function TimeLineAnalyst(props) {
    const [analystData, setAnalystData] = useState([])

    const formatToExport = (_data) => {
        //Header
        let rows = [
            ['Analista:', _data.name],
            [],
            ['Data', 'Ticket', 'Cliente', 'Titulo', 'Inicio', 'Fim', 'Tempo'],
        ]

        Object.keys(_data.timeline || {}).forEach(dateKey => {
            _data.timeline[dateKey].filter(item => item.end != null).forEach(item => {
                rows.push([
                    new Date(`${dateKey} 00:00:00`).toLocaleDateString(),
                    item.ticketId,
                    item.customerName,
                    item.titulo,
                    `${new Date(item.start).toLocaleDateString()} ${new Date(item.start).toLocaleTimeString()}`,
                    `${new Date(item.end).toLocaleDateString()} ${new Date(item.end).toLocaleTimeString()}`,
                    item.totalTime,
                ])
            })
        })

        exportToCsv(rows, `Report ${_data.name}`)
    }

    // Escape one CSV cell: wrap in quotes, double internal quotes
    const csvCell = (val) => {
        const s = val == null ? '' : String(val);
        return `"${s.replace(/"/g, '""')}"`;
    };

    const exportToCsv = function (_arrOfArr, title) {
        let CsvString = "sep=;\r\n" + _arrOfArr
            .map(row => row.map(csvCell).join(';'))
            .join('\r\n');
        CsvString = "data:application/csv," + encodeURIComponent(CsvString);
        let x = document.createElement("A");
        x.setAttribute("href", CsvString);
        x.setAttribute("download", `${title}.csv`);
        document.body.appendChild(x);
        x.click();
    };

    function groupTimelineByDate(analysts) {
        return analysts.map(analista => {
            const porData = analista.timeline.reduce((acc, item) => {
                const data = item.start.split('T')[0]; // "YYYY-MM-DD"
                if (!acc[data]) acc[data] = [];
                acc[data].push(item);
                return acc;
            }, {});

            return {
                id: analista.id,
                name: analista.name,
                timeline: porData
            };
        });
    }

    useEffect(() => {
        // axios.get(`https://apisgi.intecsolutions.com.br/nrapi/analysttimeline/${props.interval.datei.toLocaleDateString('en-ca')}/${props.interval.datef.toLocaleDateString('en-ca')}`)
        api_bd_nr.get(`/analysttimeline/${props.interval.datei.toLocaleDateString('en-ca')}/${props.interval.datef.toLocaleDateString('en-ca')}`)
            .then(resp => {
                // console.log(resp.data)

                if (resp.data && resp.data.length > 0) {
                    const groupedData = groupTimelineByDate(resp.data);
                    setAnalystData(groupedData);
                } else {
                    setAnalystData([]);
                }

            })
        // }
    }, [props.interval])

    return (
        <div className='w-full h-full'>
            {analystData.length > 0 && analystData.map(el => (
                <div key={`${el.id}`} className='flex flex-row my-3 space-x-3 w-full rounded border border-intec-200 p-5 bg-white'>
                    <div>
                        <img className='rounded-full object-cover' src={`https://apisgi.intecsolutions.com.br/api/users/getuserimg2/${el.id}`} style={{width: 70, height: 70, maxWidth: 70, maxHeight: 70}}/>
                    </div>
                    <div className='flex flex-row w-full'>
                        <div>
                            <p className='font-bold'>{el.name}</p>
                            {/* <p className='text-intec-500 text-md'>Tempo Total: {el.tempoTotalF}</p> */}

                            {el?.timeline && Object.keys(el.timeline).length > 0 && Object.keys(el.timeline).map((key, index) => (
                                <details>
                                    <summary className='text-intec-500'>
                                        <div className='flex flex-col mt-[-18px] pl-4'>
                                            <span className="m-0">{new Date(`${key} 00:00:00`).toLocaleDateString()}</span>
                                            <span className="m-0">Tempo total: {msToTime(el.timeline[key].filter(item => item.end != null).map((item0, index0) => item0.totalMs).reduce((acc, val) => acc + val, 0)).str}</span>
                                        </div>
                                    </summary>
                                    <div key={`${key}_${index}`} className='ml-8 text-intec-500'>
                                        <ul className='ml-8'>
                                            {el.timeline[key].filter(item => item.end != null).map((item, index2) => (
                                                <li key={`${item.ticket}_${index2}`} className='mb-3'>
                                                    Ticket: {item.ticketId} ({item.customerName})<br />
                                                    Título: {item.titulo}<br />
                                                    Início: {new Date(item.start).toLocaleDateString()} às {new Date(item.start).toLocaleTimeString()}<br />
                                                    Fim: {new Date(item.end).toLocaleDateString()} às {new Date(item.end).toLocaleTimeString()}<br />
                                                    Tempo: {item.totalTime}<br />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </details>
                            ))}
                        </div>

                    </div>
                    <button onClick={() => formatToExport(el)} className='w-[130px] h-[30px] bg-intec-500 text-white px-4 py-2 rounded mt-3'>Exportar CSV</button>
                    
                </div>
            ))}
        </div>
    );
}

export default TimeLineAnalyst;